<script lang="ts">
  import InlineSVG from 'svelte-inline-svg';
  import removeIcon from '../../assets/icons/circle-with-cross.svg';
  import a11yClick from '../../utils/a11y-click';

  import IconButton from '../icon-button/IconButton.svelte';

  export let onClick: (() => void) | null = null;
  export let onRemove: (() => void) | null = null;
  export let color = 'default'; // possible values: 'default', 'blue', 'green', 'yellow', 'red' or 'purple'
</script>

<style lang="postcss">
  .chip {
    position: relative;
    display: inline-flex;
    min-height: var(--ubilabs-chip-height);
    margin: var(--ubilabs-chip-margin);
    padding: var(--ubilabs-chip-padding);
    border-radius: calc(var(--ubilabs-chip-height) / 2);
    font-size: var(--ubilabs-chip-font-size);
    cursor: default;
  }

  .chip::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: currentColor;
    border-radius: calc(var(--ubilabs-chip-height) / 2);
    opacity: 0.1;
  }

  .chip.default {
    color: var(--ubilabs-chip-default-color);
  }
  .chip.default :global(.action) {
    color: var(--ubilabs-chip-default-action-color);
  }
  .chip.default.clickable:hover::before,
  .chip.default.clickable:focus::before,
  .chip.default :global(.action:hover::before),
  .chip.default :global(.action:focus::before) {
    background-color: var(--ubilabs-chip-default-action-background-color);
  }

  .chip.blue {
    color: var(--ubilabs-chip-primary-color);
  }
  .chip.blue :global(.action) {
    color: var(--ubilabs-chip-primary-action-color);
  }
  .chip.blue.clickable:hover::before,
  .chip.blue.clickable:focus::before,
  .chip.blue :global(.action:hover::before),
  .chip.blue :global(.action:focus::before) {
    background-color: var(--ubilabs-chip-primary-action-background-color);
  }

  .chip.green {
    color: var(--ubilabs-chip-secondary-1-color);
  }
  .chip.green :global(.action) {
    color: var(--ubilabs-chip-secondary-1-action-color);
  }
  .chip.green.clickable:hover::before,
  .chip.green.clickable:focus::before,
  .chip.green :global(.action:hover::before),
  .chip.green :global(.action:focus::before) {
    background-color: var(--ubilabs-chip-secondary-1-action-background-color);
  }

  .chip.yellow {
    color: var(--ubilabs-chip-secondary-2-color);
  }
  .chip.yellow :global(.action) {
    color: var(--ubilabs-chip-secondary-2-action-color);
  }
  .chip.yellow.clickable:hover::before,
  .chip.yellow.clickable:focus::before,
  .chip.yellow :global(.action:hover::before),
  .chip.yellow :global(.action:focus::before) {
    background-color: var(--ubilabs-chip-secondary-2-action-background-color);
  }

  .chip.red {
    color: var(--ubilabs-chip-secondary-3-color);
  }
  .chip.red :global(.action) {
    color: var(--ubilabs-chip-secondary-3-action-color);
  }
  .chip.red.clickable:hover::before,
  .chip.red.clickable:focus::before,
  .chip.red :global(.action:hover::before),
  .chip.red :global(.action:focus::before) {
    background-color: var(--ubilabs-chip-secondary-3-action-background-color);
  }

  .chip.purple {
    color: var(--ubilabs-chip-secondary-4-color);
  }
  .chip.purple :global(.action) {
    color: var(--ubilabs-chip-secondary-4-action-color);
  }
  .chip.purple.clickable:hover::before,
  .chip.purple.clickable:focus::before,
  .chip.purple :global(.action:hover::before),
  .chip.purple :global(.action:focus::before) {
    background-color: var(--ubilabs-chip-secondary-4-action-background-color);
  }

  .chip :global(.action) {
    display: inline-flex;
    width: calc(
      var(--ubilabs-chip-height) - 2 * var(--ubilabs-chip-action-margin)
    );
    height: calc(
      var(--ubilabs-chip-height) - 2 * var(--ubilabs-chip-action-margin)
    );
    margin: calc(
        var(--ubilabs-chip-action-margin) - var(--ubilabs-chip-padding-vertical)
      )
      calc(
        var(--ubilabs-chip-action-margin) -
          var(--ubilabs-chip-padding-horizontal)
      )
      calc(
        var(--ubilabs-chip-action-margin) - var(--ubilabs-chip-padding-vertical)
      )
      var(--ubilabs-chip-action-margin);
    padding: var(--ubilabs-chip-action-padding);
    border-radius: 50%;
  }

  .chip:focus-visible,
  .chip :global(.action:focus-visible) {
    outline: none;
    box-shadow: var(--ubilabs-focus-box-shadow);
  }
</style>

<div
  class="chip {color}"
  class:clickable={Boolean(onClick)}
  on:click|preventDefault|stopPropagation={onClick}
  on:keypress|preventDefault|stopPropagation={event => {
    if (onClick && a11yClick(event)) {
      onClick();
    }
  }}
  tabIndex={onClick ? 0 : -1}>
  <slot />
  {#if onRemove}
    <IconButton
      class="action"
      on:click={onRemove}
      on:keypress={event => {
        if (onRemove && a11yClick(event)) {
          onRemove();
        }
      }}>
      <InlineSVG src={removeIcon} />
    </IconButton>
  {/if}
</div>
